import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveStudents } from "./retrieve-students";
import type { StudentListElementVM } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<StudentListElementVM[]> = { fetching: "idle", data: [] };

export const retrieveStudentsReducer = createReducer<RetrievalState<StudentListElementVM[]>>(initialState, builder => {
  builder.addCase(retrieveStudents.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveStudents.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveStudents.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
